/**
 * Encadré en tête d'un modal admin / PSC : rappelle chez qui on s'apprête à créer.
 * Une ligne sans valeur n'est pas affichée.
 */
export const ContextSummary = ({
  rows,
}: {
  rows: { label: string; value: string }[];
}) => (
  <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 bg-grey-light/50 rounded-lg px-4 py-2 text-sm text-default-text">
    {rows
      .filter((row) => row.value)
      .map((row) => (
        <div key={row.label} className="contents">
          <dt className="text-grey-readable">{row.label}</dt>
          <dd className="font-oxaniumMedium">{row.value}</dd>
        </div>
      ))}
  </dl>
);
